import { Field, useFormikContext } from 'formik';
import { useEffect } from 'react';
import { ConcessionOrganizationUserRoles, Contract, useConcessionOrganizationUsersLazyQuery } from '../../generated/graphql';
import { ContractConcessionOrganizationUser } from '../../types/types';
import { ContractUserAutocomplete } from '../ContractUserAutocomplete/ContractUserAutocomplete';

export const matchOrganization = (contractConcessionOrganizations: any) => {
    const found = contractConcessionOrganizations?.find((obj: any) => {
        return +obj?.concessionOrganization?.organizationType?.id === 2 || +obj?.organizationType?.id === 2
    })
    return found?.concessionOrganization?.id || found?.id
}

export default function ExternalAuthorityField(props: ContractConcessionOrganizationUser) {
    const { disabled } = props
    const context = useFormikContext<Contract>()
    const [query, { data }] = useConcessionOrganizationUsersLazyQuery()

    const name = "contractUsers"
    const label = "Responsável Contrato"
    const options = data?.concessionOrganizationUsers?.nodes || []
    const role = ConcessionOrganizationUserRoles.Externalauthority
    const contractConcessionOrganizations = context?.values["contractConcessionOrganizations"]

    useEffect(() => {
        const id = matchOrganization(contractConcessionOrganizations)
        if (id) {
            query({ variables: { filter: { concessionOrganization: { id: { eq: id } }, role: { eq: role } } } })
        }
    }, [contractConcessionOrganizations, query, role])

    return (
        <div>
            <Field
                name={name}
                component={ContractUserAutocomplete}
                options={options}
                label={label}
                role={role}
                disabled={disabled}
            />
        </div>
    )
}
